const defaultState = () => ({
  currentDiscountLineIndex: 0,
  discountDialogOpened: false,
});

const mutations = {
  openDiscountDialog(state, payload = {}) {
    state.discountDialogOpened = true;
    state.currentDiscountLineIndex = payload.index ?? null;
  },
  closeDiscountDialog(state) {
    state.discountDialogOpened = false;
    state.currentDiscountLineIndex = null;
  },
};

const actions = {
  openDiscountDialog({ commit }, payload) {
    commit('openDiscountDialog', payload);
  },
  closeDiscountDialog({ commit }) {
    commit('closeDiscountDialog');
  },
  applyInvoiceLineDiscount({ commit }, { index, discountData }) {
    commit('invoiceForm/applyDiscount', {
      index,
      discountData,
      isDiscountLine: true,
    }, { root: true });
  },
  applyInvoiceWideDiscount({ commit, rootGetters, rootState }, discountData) {
    const discountLine = rootGetters['invoiceForm/InvoiceWideDiscountLine'];
    const index = discountLine ? rootState.invoiceForm.lines.findIndex(line => line === discountLine) : -1;

    if (index !== -1) {
      commit('invoiceForm/applyDiscount', {
        index,
        discountData,
        isDiscountLine: false,
      }, { root: true });
    } else {
      commit('invoiceForm/addInvoiceItem', {
        ...discountData,
        is_discount_line: false,
      }, { root: true });
    }
  },
  applyDiscount({ dispatch, state }, { discountData }) {
    const { currentDiscountLineIndex } = state;

    if (currentDiscountLineIndex !== null && currentDiscountLineIndex >= 0) {
      dispatch('applyInvoiceLineDiscount', {
        index: currentDiscountLineIndex,
        discountData,
      });
    } else {
      dispatch('applyInvoiceWideDiscount', discountData);
    }
  },
};

const getters = {
  isDiscountDialogOpen: state => state.discountDialogOpened,
  currentDiscountLineIndex: state => state.currentDiscountLineIndex,
};

export default {
  namespaced: true,
  state: defaultState(),
  getters,
  actions,
  mutations,
};
